export const PODPOLOZKY = 'Podřízené položky';
export const MEZIROCNI_SROVNANI = 'Meziroční srovnání';
export const PRUBEH = 'Průběh';
export const MEZIROCNI_PRUBEH = 'Meziroční průběh';
